import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

// ui
import DashboardContainer from '../../containers/Dashboard';
import AuthUserContainer from '../../containers/AuthUser';
import FMPSectionCard from '../../components/ui/FMPSectionCard';

// icons
import GasPump from '../../images/icons/gasPump.svg';
import SmsRequestIcon from '../../images/icons/smsIcon.png';
import SleepIcon from '../../images/icons/sleepIcon.png';
import IncomingDocuments from '../../images/icons/incomingDocuments.svg';
import RebateIcon from '../../images/icons/rebateIcon.png';

const styles = (theme) => {
	return {
		root: {
			width: '100%',
			height: 'auto',
			zIndex: 1,
			overflow: 'hidden',
			backgroundColor: '#e5e5e6',
		},
		panel: {
			marginTop: 30,
		},
		emptyPanel: {
			minHeight: 270,
			fontWeight: 100,
			color: '#aaa',
			fontSize: 30,
			marginTop: 30,
		},
		innerPaper: {
			padding: 10,
			paddingTop: 5,
			textAlign: 'left',
			fontSize: 14,
			[theme.breakpoints.up('md')]: {
				padding: 40,
				paddingTop: 30,
			},
		},
		lastFtpCheck: {
			//marginTop : 20,
			//color : "#888"
		},
		ftpSection: {
			lineHeight: 1.6,
			marginTop: 10,
		},
		title: {
			textTransform: 'uppercase',
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
			marginBottom: 5,
		},
		label: {},

		labelDate: {
			fontSize: 12,
			fontWeight: 100,
			color: '#999',
		},
		value: {
			fontWeight: 600,
		},
		statusIcon: {
			position: 'absolute',
			right: 0,
		},
		ftpWarning: {
			color: '#FFC107',
		},
		ftpGood: {
			color: '#4CAF50',
		},
		ftpStatusIcon: {
			width: 14,
			height: 14,
			verticalAlign: 'middle',
			paddingLeft: 5,
		},
		ftpStatusIconLarge: {
			width: 32,
			height: 32,
			verticalAlign: 'middle',
		},
		dataSection: {
			marginTop: 25,
			lineHeight: 1.6,
		},
		dgsButton: {
			position: 'relative',
			right: 0,
			borderRadius: 100,
		},
		dgsButtonContainer: {
			display: 'flex',
			justifyContent: 'flex-end',
		},
		masthead: {
			textAlign: 'left',
			fontSize: 24,
			color: '#666',
			letterSpacing: 0,
			textTransform: 'uppercase',
			fontWeight: 300,
			marginBottom: 15,
			marginTop: 15,
			//margin: '2px 0px 5px 0px',
			position: 'relative',
			marginLeft: 0,

			[theme.breakpoints.up('sm')]: {
				fontWeight: 300,
				fontSize: 22,
				//margin: '10px 0px 10px 0px',
			},
			[theme.breakpoints.up('md')]: {
				fontSize: 30,
				//margin: '10px 0px 10px 0px',
			},
		},
	};
};

class RetailManagementDashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		const { classes } = this.props;

		return (
			<>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<div className={classes.masthead}>Retail Management Dashboard</div>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FMPSectionCard
							title={'Retail Prices'}
							icon={GasPump}
							description={`View and manage retail pricing data for all stations. 
							Compare current prices against previous prices, track price changes, 
							and analyze estimated margins. Includes filtering by region and 
							ownership group with comprehensive station statistics.
							`}
							url={'/reports/retailPrices'}
						/>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FMPSectionCard
							title={'SMS Requests'}
							icon={SmsRequestIcon}
							description={`Manage SMS pricing requests sent to station contacts. 
							Track pending requests, triage responses, and monitor completion status. 
							Includes tools for handling unknown replies and testing multi-site SMS campaigns.
							`}
							url={'/retailPricing/pricingRequests'}
						/>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FMPSectionCard
							title={'Ignore List'}
							icon={SleepIcon}
							description={`Manage stations that should be ignored for retail pricing updates. 
							Add or remove stations from the ignore list to prevent automatic price 
							updates from GasBuddy or other sources. Useful for stations with 
							special pricing arrangements or temporary issues.
							`}
							url={'/retailPricing/addIgnore'}
						/>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FMPSectionCard
							title={'Pricing Import'}
							icon={IncomingDocuments}
							description={`Import retail pricing data from external sources including G&M, 
							H&S, and Pearson bulk lists. Parse and validate pricing data before 
							applying to stations. Includes options to lock prices for specified 
							periods to prevent automatic overrides.
							`}
							url={'/retailPricing/import'}
						/>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FMPSectionCard
							title={'Rebate Campaigns'}
							icon={RebateIcon}
							description={`Create and manage rebate campaigns for stations. 
							These are used in various places in the FMP system to control groupings of stations like the Fuel Forecast. 
							`}
							url={'/rebateCampaign/rebateCampaigns'}
						/>
					</Grid>
				</Grid>
			</>
		);
	}
}

RetailManagementDashboard.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), DashboardContainer, AuthUserContainer])(
	RetailManagementDashboard
);
